import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getAssignCubesMachinOperatorsToGraders,
  getFillerAcceptedProcessStockList,
  updateFillerStock,
} from "api";
import { categoriTypes } from "components/StaticData";

class ProcessStockAccepted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      totalSize: 10,
      sizePerPage: 10,
      // productData: products,
      stockList: [],
    };
  }
  getStockList() {
    const stock = getFillerAcceptedProcessStockList({
      page: this.state.page,
      limit: this.state.sizePerPage,
      dataEntryAcceptStatus: "NA",
      salesOfficeAcceptStatus: "NA",
    })
      .then(x => {
        if (x.success) {
          this.setState({
            totalSize: x.data.count,
            stockList: x.data.fillerStocks,
          });
        }
      })
      .catch(err => console.log(err));
  }
  componentDidMount() {
    // const stock = await getAssignCubesMachinOperatorsToGraders({page:this.state.page,limit:this.state.sizePerPage,graderStatus:"P"})
    this.getStockList();
  }
  sendDataEntry(data) {
    console.log(data);
    updateFillerStock({ id: data.id, dataEntryAcceptStatus: data.status })
      .then(x => {
        console.log(x);
        if (x.success) {
          this.getStockList();
        }
      })
      .catch(err => console.log(err));
  }
  render() {
    const columns = [
      {
        dataField: "id",
        text: "#",
        hidden: true,
      },
      {
        dataField: "srNo",
        text: "Inward ID",
        sort: true,
        formatter: (cell, row) => {
          return row.stock.id;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stock.partyCode;
        },
      },
      {
        dataField: "weight",
        text:`${this.props.t('Weight')}`,
        sort: true,
        formatter: (cell, row) => {
          if (row.si.length == 0) return 0;
          else
            return row.si
              .map(x => x.weight)
              .reduce((total, num) => {
                return total + num;
              });
        },
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        sort: true,
        formatter: (cell, row) => {
          if (row.si.length == 0) return 0;
          else
            return row.si
              .map(x => x.pieces)
              .reduce((total, num) => {
                return total + num;
              });
        },
      },
      {
        dataField: "hpht",
        text: "CVD",
        sort: true,
        formatter: (cell, row) => {
          if (row.si.filter(x => x.categoryId == 1).length == 0) return 0;
          else
            return row.si
              .filter(x => x.categoryId == 1)
              .map(x => x.weight)
              .reduce((total, num) => {
                return total + num;
              });
        },
      },
      {
        dataField: "lpht",
        text: "LPHT",
        sort: true,
        formatter: (cell, row) => {
          if (row.si.filter(x => x.categoryId == 2).length == 0) return 0;
          else
            return row.si
              .filter(x => x.categoryId == 2)
              .map(x => x.weight)
              .reduce((total, num) => {
                return total + num;
              });
        },
      },
      {
        dataField: "real",
        text: "REAL",
        sort: true,
        formatter: (cell, row) => {
          if (row.si.filter(x => x.categoryId == 3).length == 0) return 0;
          else
            return row.si
              .filter(x => x.categoryId == 3)
              .map(x => x.weight)
              .reduce((total, num) => {
                return total + num;
              });
        },
      },
      {
        dataField: "jiram",
        text: "JIRAM",
        sort: true,
        formatter: (cell, row) => {
          if (row.si.filter(x => x.categoryId == 4).length == 0) return 0;
          else
            return row.si
              .filter(x => x.categoryId == 4)
              .map(x => x.weight)
              .reduce((total, num) => {
                return total + num;
              });
        },
      },
      {
        dataField: "assignGraderToFillerStock",
        text:`${this.props.t('Cycle')}`,
        sort: true,
        formatter: (cell, row) => {
          return cell.cycle;
        },
      },
      {
        dataField: "status",
        text: `${this.props.t('Status')}`,
        sort: true,
        formatter: (cell, row) => {
          return (
            <div>
              <div className="form-check form-switch d-inline-block">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="site_state"
                  value={row.dataEntryAcceptStatus == "NA" ? false : true}
                  onChange={e => {
                    this.sendDataEntry({
                      id: row.id,
                      status: row.dataEntryAcceptStatus == "NA" ? "P" : "NA",
                    });
                  }}
                />
                <label
                  htmlFor="site_state"
                  className="form-check-label pt-4"
                ></label>
              </div>
            </div>
          );
        },
      },
      {
        dataField: "viewdetails",
        text:`${this.props.t('View Details')}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            {row.stockFillerInWards.length == row.si.length && (
              <Link
                to={{
                  pathname: "/cycle1-verify-accept",
                  query: { isEdit: 1, data: row },
                }}
              >
                <button className="py-2 px-2 border-0 rounded">
                  <img src="images/dashboard-images/edit.svg" />
                </button>
              </Link>
            )}
            <Link
              to={{
                pathname: "/grader-view-verify-accept",
                query: { isEdit: 3, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
    ];
    const expandRow = {
      renderer: row => {
        let columns = [
          {
            dataField: "id",
            text: "Inward ID ",
            sort: true,
          },
          {
            dataField: "category",
            text: `${this.props.t('Category')}`,
            sort: true,
            formatter: (cell, row1) => {
              return categoriTypes.filter(z => z.value === row1.categoryId)[0]
                .label;
            },
          },
          {
            dataField: "pieces",
            text:`${this.props.t('Pieces')}`,
            sort: true,
            formatter: (cell, row1) => {
              return (
                row.si.filter(y => y.id === row1.id).length &&
                row.si.filter(y => y.id === row1.id)[0].pieces
              );
            },
          },
          {
            dataField: "weight",
            text:`${this.props.t('Weight')}`,
            sort: true,
            formatter: (cell, row1) => {
              return (
                row.si.filter(y => y.id === row1.id).length &&
                row.si.filter(y => y.id === row1.id)[0].weight
              );
            },
          },

          {
            dataField: "boliman",
            text: "boli man",
            sort: true,
            formatter: (cell, row1) => {
              return row.si.filter(y => y.id === row1.id).length
                ? row.si.filter(y => y.id === row1.id)[0].ftm[0].ms[0].mtg[0]
                    .user.name
                : "Pending";
            },
          },
        ];
        return (
          <BootstrapTable
            keyField={"id"}
            data={row.stockFillerInWards}
            columns={columns}
          />
        );
      },
      showExpandColumn: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return <b>-</b>;
        }
        return <b>...</b>;
      },
    };
    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.GraderStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title

    document.title = "grader flow";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.stockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                    {this.props.t('PROCESSED STOCK ACCEPTED (OUTWARD)')}                     
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {" "}
                                  {this.props.t('Showing')}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}{" "}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(ProcessStockAccepted);
